export const brandColors = {
  amazonMusic: "#1ad2fb",
  apple: "#000000",
  applePodcasts: "#852cc4",
  facebook: "#1877F2",
  google: "#4285F4",
  instagram: "#C32AA3",
  linkedin: "#0A66C2",
  spotify: "#1DB954",
  twitter: "#1DA1F2",
};
